import type { FilterToggle } from "../fhir-section";
import type { ConditionRowData } from "./table-data";

interface ConditionRowDataWithHccSortValue extends ConditionRowData {
  hccSortValue: number;
}

/**
 * Create static filter toggles for conditions
 * Always shows Problem List Item and Encounter Diagnosis categories,
 * and HCC/Chronic labels
 */
export function createConditionsFilterV1(): FilterToggle[] {
  const filterToggles: FilterToggle[] = [];

  // Static category filters
  filterToggles.push({
    label: "Problem List Item",
    groupLabel: "Category",
    isChecked: false,
    filterFn: (data: ConditionRowData) => data.category === "Problem List Item",
  });

  filterToggles.push({
    label: "Encounter Diagnosis",
    groupLabel: "Category",
    isChecked: false,
    filterFn: (data: ConditionRowData) => data.category === "Encounter Diagnosis",
  });

  // Static condition filters
  filterToggles.push({
    label: "HCC",
    groupLabel: "Label",
    isChecked: false,
    filterFn: (data: ConditionRowData) => data.isHcc,
    sortFn: (a: ConditionRowDataWithHccSortValue, b: ConditionRowDataWithHccSortValue) => {
      const hccSortA = a.hccSortValue || 0;
      const hccSortB = b.hccSortValue || 0;
      return hccSortA - hccSortB;
    },
  });

  filterToggles.push({
    label: "Chronic",
    groupLabel: "Label",
    isChecked: false,
    filterFn: (data: ConditionRowData) => data.isChronic,
  });

  return filterToggles;
}
